export default __webpack_public_path__ + "static/media/logokey.6ab319f1.svg";